import { Check, ArrowLeft } from 'lucide-react';
import { PROFILE_STEPS } from 'pages/Profile/helper';
import { useNavigate } from 'react-router-dom';
import { PORTAL_ROUTES } from 'utils/constants';
import { Button } from 'react-daisyui';

const STATUS_STYLE = {
  done: { circle: 'bg-success-50 text-success-600 border-2 border-success-500 sm:bg-success-500 sm:text-white', label: 'text-success-600 font-semibold' },
  active: { circle: 'bg-teamcare-blue text-white ring-4 ring-teamcare-blue/15', label: 'text-teamcare-blue font-bold' },
  open: { circle: 'bg-white text-teamcare-blue border-2 border-teamcare-blue', label: 'text-secondary-500 font-medium' },
};

const ACTIVE_MOBILE = 'max-sm:border-teamcare-blue';

const Stepper = ({ completion = {}, activeId, onStepClick }) => {
  const navigate = useNavigate();

  return (
    <div className="flex-shrink-0 relative flex items-center justify-center gap-4 border-b border-gray-100 px-5 py-4 lg:px-7">
      <Button
        size="sm"
        variant="outline"
        onClick={() => navigate(PORTAL_ROUTES.PROFILE)}
        className="static shrink-0 sm:absolute sm:left-5 lg:left-7 flex items-center gap-1.5 border-gray-200 text-secondary-600 hover:text-secondary-900 hover:border-gray-300 bg-white hover:bg-white"
      >
        <ArrowLeft size={14} />
        <span className="hidden lg:inline">All forms</span>
      </Button>

      <div className="flex min-w-0 flex-1 max-w-[640px] items-start sm:w-4/5 sm:flex-none">
        {PROFILE_STEPS.map((step, i) => {
          const Icon = step.icon;
          const done = !!completion[step.id];
          const isActive = step.id === activeId;
          const status = done ? 'done' : isActive ? 'active' : 'open';
          const { circle } = STATUS_STYLE[status];
          const { label } = STATUS_STYLE[isActive ? 'active' : status];

          return (
            <div key={step.id} className="relative flex flex-1 flex-col items-center">
              {i < PROFILE_STEPS.length - 1 && (
                <span className={`absolute left-1/2 top-4 z-0 h-[2.5px] w-full ${done ? 'bg-success-500' : 'bg-secondary-200'}`} />
              )}
              <button
                type="button"
                onClick={() => onStepClick(step)}
                className={`relative z-[1] flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-full text-sm font-bold transition-all ${circle} ${isActive ? ACTIVE_MOBILE : ''}`}
              >
                <Icon size={16} className="sm:hidden" />
                {done ? (
                  <Check size={15} strokeWidth={3.2} className="hidden sm:block" />
                ) : (
                  <span className="hidden sm:block">{i + 1}</span>
                )}
                {done && (
                  <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-success-500 ring-2 ring-white sm:hidden">
                    <Check size={10} strokeWidth={4} className="text-white" />
                  </span>
                )}
              </button>
              <span className={`mt-[7px] hidden whitespace-nowrap text-center text-[11.5px] sm:block ${label}`}>{step.navLabel}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
